import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Grid } from 'semantic-ui-react';
import SpecialCategory from './SpecialCategory';
import Carousel from '../../../darkmatter/Carousel';
import IndicatorGroup from '../../../organisms/ImageCollection/components/IndicatorGroup';
import { MenuCategoryPropType, MenuItemPropType } from '../../../services/proptypes';
import ImageCaption from '../../SpecialImageCaption';
import { getCategoryNameFromItems } from '../utils';
import './SpecialCarousel.css';
var SpecialCarousel = /*#__PURE__*/function (_React$Component) {
  _inherits(SpecialCarousel, _React$Component);
  var _super = _createSuper(SpecialCarousel);
  function SpecialCarousel() {
    _classCallCheck(this, SpecialCarousel);
    return _super.apply(this, arguments);
  }
  _createClass(SpecialCarousel, [{
    key: "renderContent",
    value: function renderContent(items) {
      var _this$props = this.props,
        autoScroll = _this$props.autoScroll,
        showIndicator = _this$props.showIndicator,
        groupByCategory = _this$props.groupByCategory,
        categories = _this$props.categories,
        precision = _this$props.precision;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          overflowY: 'hidden',
          overflowX: 'hidden'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Carousel, {
        totalNumberOfItems: items.length,
        autoScroll: autoScroll,
        numberOfDisplayItems: 3
      }, function (_ref) {
        var currentIndex = _ref.currentIndex,
          changeCurrentIndex = _ref.changeCurrentIndex,
          getDisplayItemIndices = _ref.getDisplayItemIndices;
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Grid, {
          columns: 3
        }, getDisplayItemIndices().map(function (index) {
          return /*#__PURE__*/React.createElement(Grid.Column, null, /*#__PURE__*/React.createElement(ImageCaption, _extends({
            gatsbyImage: items[index].gatsbyImage,
            image: items[index].image,
            name: items[index].name,
            description: items[index].description,
            variations: items[index].variations,
            precision: precision
          }, !groupByCategory && {
            // eslint-disable-next-line no-underscore-dangle
            category: getCategoryNameFromItems(items[index]._id, categories)
          })));
        })), showIndicator && /*#__PURE__*/React.createElement("div", {
          className: "special-carousel-center-indicator-groups"
        }, /*#__PURE__*/React.createElement(IndicatorGroup, {
          images: items,
          currentIndex: currentIndex,
          changeCurrentIndex: changeCurrentIndex
        })));
      })));
    }
  }, {
    key: "renderWithCategory",
    value: function renderWithCategory() {
      var _this = this;
      var _this$props2 = this.props,
        items = _this$props2.items,
        categories = _this$props2.categories;
      return /*#__PURE__*/React.createElement(SpecialCategory, {
        specials: {
          items: items,
          categories: categories
        }
      }, function (_ref2) {
        var specialItems = _ref2.items;
        return _this.renderContent(specialItems);
      });
    }
  }, {
    key: "renderWithoutCategory",
    value: function renderWithoutCategory() {
      var items = this.props.items;
      return this.renderContent(items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        groupByCategory = _this$props3.groupByCategory,
        categories = _this$props3.categories;
      return groupByCategory && categories.length ? this.renderWithCategory() : this.renderWithoutCategory();
    }
  }]);
  return SpecialCarousel;
}(React.Component);
SpecialCarousel.defaultProps = {
  categories: [],
  autoScroll: true,
  showIndicator: true,
  groupByCategory: false,
  precision: 2
};
export default SpecialCarousel;